<div class="outer-container text-center">
  <img src="assets/images/logo.jpg" alt="APLogo"/>
  <div class="row mt-20">
    <div class="col-1"></div>
    <div class="col-10 signIn_container">
      <h4 class="signIn_text">Sign In</h4>
      <form [formGroup]='loginForm' (ngSubmit)="getToken()">
        <div class="form-group">
          <input class="form-control mt-30" formControlName='email' type="email" placeholder="Email*"
                 [ngClass]="{ 'is-invalid': loginForm.controls.email.touched && loginForm.controls.email.invalid }">
        </div>
        <div class="input-group">
          <input [type]="isPassVisible ? 'text' : 'password'" class="form-control" formControlName='password' placeholder="Password*"
                 [ngClass]="{ 'is-invalid': loginForm.controls.password.touched && loginForm.controls.password.invalid }">
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa" [ngClass]="{ 'fa-eye-slash': !isPassVisible, 'fa-eye': isPassVisible }" (click)="isPassVisible = !isPassVisible"></i>
            </span>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="loginForm.invalid" class="btn btn-block btn-info mt-20 signIn_btn">SIGN IN&nbsp;&nbsp;<i class="fas fa-sign-in-alt"></i></button>
        </div>
      </form>
    </div>
    <div class="col-1"></div>
  </div>
</div>
<div class="appVersion"><b>WebApp {{appVersion}}</b></div>
